import { Component, OnInit, OnDestroy, ViewChild, ElementRef, ChangeDetectorRef, ChangeDetectionStrategy } from '@angular/core';
import { ActivatedRoute, Router, NavigationExtras } from '@angular/router';
import { TranslateDirective, TranslatePipe, TranslateService } from '@ngx-translate/core';
import { OTError } from '@opentok/client';
import { Observable, BehaviorSubject, Subject, of } from 'rxjs';
import { delay, distinctUntilChanged, take } from 'rxjs/operators';
import { ApiConectateService } from '../../api/apiConectate';
import { ApiTokboxService } from '../../api/apiTokbox';
import { ApiTokboxNetworkTestService } from '../../api/apiTokbox/apiTokboxNetworkTest.service';
import { ApiTunningService } from '../../api/apiTunning';
import {
  IResultTest,
  IUAParserInfo,
  IPostTunningRequest,
} from '../../api/apiTunning/apiTunning.models';
import { ScrollToBottomDirective } from '../../directives/scroll-to-bottom.directive';
import { PARTICIPANTS_CONSTANTS } from '../../constants/participants.constants';
import { StateHandlerService } from '../../services/state-handler/state-handler.service';
import { EnvironmentService } from '../../services/enviroment/environment.service';
import { UtilsService } from '../../services/utils/utils.service';
import { SessionStorageService } from '../../services/session-storage/session-storage.service';
import { TooltipSupportService } from '../../services/tooltip-support/tooltip-support.service';
import { VIDEOCONFERENCE_CONSTANTS } from '../../constants/videoconference.constants';
import { ROUTES_CONSTANTS } from '../../constants/routes.constants';
import { AsyncPipe, JsonPipe, NgClass, NgStyle } from '@angular/common';
import { SupportTooltipComponent } from '../../components/support-tooltip/support-tooltip.component';
import { environment } from '../../../environments/environment';

// Add interface to extend HTMLAudioElement with setSinkId method
interface HTMLAudioElementWithSinkId extends HTMLAudioElement {
  setSinkId(deviceId: string): Promise<void>;
}

/**
 * Componente custom de test pata Mutua Universal
 * Funciones:
 * - Crear un publisher de OT para las pruebas. No necesita sesión de OT ya que son pruebas.
 * - Test de altavoz, microfono y video
 */
@Component({
  standalone: true,
  imports: [
    TranslatePipe,
    TranslateDirective,
    NgClass,
    SupportTooltipComponent,
    AsyncPipe,
    NgStyle
  ],
  selector: 'sas-mutua-network-test',
  templateUrl: './mutua-network-test.component.html',
  styleUrls: ['./mutua-network-test.component.scss'],
})
export class MutuaNetworkTestComponent implements OnInit, OnDestroy {
  @ViewChild('publisherDiv') publisherDiv?: ElementRef;
  /**
   * ElemetRef q devuelve la directiva para obtener su ScrollTop
   */
  @ViewChild(ScrollToBottomDirective) scrollPage?: ScrollToBottomDirective;
  levelWidth = 0;
  audioTestObject?: HTMLAudioElementWithSinkId;
  publisher?: OT.Publisher;
  ot: any;
  ROLES_TYPE = PARTICIPANTS_CONSTANTS.ROL_TYPE;
  audioStartTest = false;
  audioOutputTest = false;
  micStartTest = false;
  camStartTest = false;
  audioTest?: boolean;
  videoTest?: boolean;
  networkTest?: boolean;
  devicesTestActivate?: boolean;
  dualCam?: boolean;
  showConnectivityTestResults = true;
  roleType?: string;
  welcomeMessage = true;
  audioManualTestEnabled = false;
  audioManualTestInfo = false;
  audioManualTest = false;
  micManualTestEnabled = false;
  micManualTestInfo = false;
  micManualTest = false;
  camManualTestEnabled = false;
  camManualTestInfo = false;
  camManualTest = false;
  mySelf?: string;
  noConnectivityTestPassed = false;
  noAudioSpeakersTestPassed = false;
  phoneNumberToCall: string = '';
  typeDeviceErrorMessage?: string;
  /**
   * resultados del TUNNING a guardar en BBDD
   */
  tunningResults: IResultTest = {
    resultNetwork: false,
    resultCamera: false,
    resultMicrophone: false,
    resultBrowser: false,
    resultSpeakers: false,
  };

  /**
   * support phone
   */
  hide: boolean = true;
  supportPhone: string;
  public openCloseTooltipSupport: Observable<boolean>;

  /**
   * Si se muestra el modal de lista blanca de navegadores
   */
  showWhiteList = false;
  /**
   * Si se ha mostrado el modal de lista blanca de navegadores
   */
  showedAdvice = false;
  /**
   * Si se muestra el modal de lista blanca de navegadores
   */
  whiteListVersions = {
    chromeWindows: '',
    chromeAndroid: '',
    safari: '',
    edgeWindows: '',
  };
  /**
   * BS para informar si hay error de audio y video
   */
  private isMediaErrorBS: BehaviorSubject<boolean>;
  public isMediaError$: Observable<boolean>;
  audioDevices: any;
  videoDevices: any;
  isOpen: boolean = false;
  audioOutputDevices: any;

  defaultAudioOutputDeviceId: string | null = null;
  selectedAudioOutputDeviceId: string | null = null;

  defaultVideoInputDeviceId: string | null = null;

  lastFilteredAudioDevices: any;
  lastFilteredAudioOutputDevices: any;
  /*
   * Método que abre el supportNumberTooltip.
   */
  public showSupportNumber() {
    this.tooltipSupportService.setCloseOpenTooltipSupport(true);
    this.cdr.detectChanges();
  }

  /**
   * BS para informar a la vista si el dispositivo es un móvil
   */
  private isMobileBS: BehaviorSubject<boolean>;
  public isMobile$: Observable<boolean>;

  /**
   * BS para informar a la vista si el dispositivo es una tablet
   */
  private isTabletBS: BehaviorSubject<boolean>;
  public isTablet$: Observable<boolean>;

  /**
   * Si se muestra el modal de error
   */
  devicesErrorMessage = false;
  /**
   * Translate del mensaje del modal
   */
  popUpMessage?: string;
  /**
   * Datos del test a mostrar en desarrollo
   */
  testResultsShownInDevelop: any;
  private frameRateRecommended?: number;
  /**
   * Contador para filtrar y que no salgan tantos logs de los eventos de nivel de audio
   */
  audioLevelCont = 0;
  /**
   * Todos los num. de contacto están a null
   */
  allPhonesNull = false;

  /**
   * Subject para el unsubscribe de los observables al destriur el componente.
   */
  private ngUnsubscribe: Subject<void> = new Subject<void>();

  getNetWorkTestCredentialsError?: boolean;
  attendantId?: string;

  private showLostSignalModalBS: BehaviorSubject<boolean> = new BehaviorSubject(false);
  showLostSignalModal$: Observable<boolean> = this.showLostSignalModalBS
    .asObservable()
    .pipe(delay(500));
  constructor(
    private readonly stateHandlerSrv: StateHandlerService,
    public readonly enviroment: EnvironmentService,
    private readonly utils: UtilsService,
    private readonly translateService: TranslateService,
    private readonly activatedRoute: ActivatedRoute,
    private readonly router: Router,
    private readonly opentokService: ApiTokboxService,
    private readonly apiConectateService: ApiConectateService,
    private readonly opentokNetworkTestSrv: ApiTokboxNetworkTestService,
    private readonly apiTunningService: ApiTunningService,
    private readonly sessionStorageService: SessionStorageService,
    private readonly tooltipSupportService: TooltipSupportService,
    private readonly cdr: ChangeDetectorRef
  ) {
    this.audioTestObject = new Audio() as HTMLAudioElementWithSinkId;
    this.isTabletBS = new BehaviorSubject(false);
    this.isTablet$ = this.isTabletBS
      .asObservable()
      .pipe(delay(200), distinctUntilChanged());
    this.isMobileBS = new BehaviorSubject(false);
    this.isMobile$ = this.isMobileBS
      .asObservable()
      .pipe(delay(200), distinctUntilChanged());
    this.isMediaErrorBS = new BehaviorSubject(false);
    this.isMediaError$ = this.isMediaErrorBS.asObservable();
    this.openCloseTooltipSupport = of(false);
    this.supportPhone = this.enviroment.data.tech_support_phone;
  }

  /**
   * Se verifica si el dispositivo es un móvil o tablet
   */
  ngAfterViewInit(): void {
    const isMobileValue = this.utils.isMobile();
    const isTabletValue = this.utils.isTablet();
    console.log('Device detection - isMobile:', isMobileValue);
    console.log('Device detection - isTablet:', isTabletValue);

    this.isMobileBS.next(isMobileValue);
    this.isTabletBS.next(isTabletValue);

    // Subscribe to observables to verify values after async pipe
    this.isMobile$.subscribe((value) => console.log('isMobile$ observable value:', value));
    this.isTablet$.subscribe((value) => console.log('isTablet$ observable value:', value));

    this.utils.isSafariOrUiwebview();
    this.utils.isUiwebview();
    this.utils.isIOsMobilityUAPArser();
    this.utils.isIOsMobilityWebViewUAPArser();
    const lostSignal = !!localStorage.getItem('openLostSignalModal');
    if (lostSignal) {
      this.showLostSignalModalBS.next(lostSignal);
    }
    localStorage.removeItem('openLostSignalModal');
    localStorage.removeItem('lostSignalRedirect');

       // Apply the selected audio output device after the view is initialized
    // Use a longer timeout to ensure all components are fully initialized
    setTimeout(() => {
      this.presetAudio();
    }, 1000);


    this.cdr.detectChanges();
  }

  presetAudio(){
    if (this.selectedAudioOutputDeviceId && this.ot) {
        console.log('Automatically selecting default audio device:', this.selectedAudioOutputDeviceId);
        this.onSeleccionarAudio(this.selectedAudioOutputDeviceId);
      } else if (this.defaultAudioOutputDeviceId && this.ot) {
        console.log('Selecting default audio device from defaultAudioOutputDeviceId:', this.defaultAudioOutputDeviceId);
        this.selectedAudioOutputDeviceId = this.defaultAudioOutputDeviceId;
        this.onSeleccionarAudio(this.defaultAudioOutputDeviceId);
      }
      this.cdr.detectChanges();
  }

  /**
   * Se inicia el test
   */
  ngOnInit(): void {
    this.checkSupportedbrowser();
    console.log('¡¡¡INICIANDO TEST!! @@@------------------------------>');
    this.devicesTestActivate =
      this.enviroment.data?.features?.network_test_style === this.enviroment.data?.appClientName;

    if (this.devicesTestActivate) {
      /**
       * BS para informar si hay error de audio y video
       * TODO : Si se quiere habilitar el modal con recarga de página
       * q está en mutua-network-test (descomentar tmb para ello la parte de código de dicho componente)
       */
      // this.isMediaErrorBS.next(null);
      // this.opentokNetworkTestSrv.isMediaError$
      //   .pipe(takeUntil(this.ngUnsubscribe))
      //   .subscribe((error: OTError) => {
      //     if (error && error.name) {
      //       this.catchErrorMediaDevices(error);
      //     }
      // });
      this.attendantId =
        this.activatedRoute.snapshot.queryParams[VIDEOCONFERENCE_CONSTANTS.URL_PARAM_ATTENDANT];
      this.getMedia();
      this.attendantsData();
    }
    this.cdr.detectChanges();
  }

  checkSupportedbrowser() {
    const deviceInfoObj: IUAParserInfo = this.utils.getDeviceInfo();
    console.log('deviceInfoObj request', deviceInfoObj);
    const supportedBrowsers = this.enviroment.data?.features?.supportedBrowsers;
    let showWhiteList = false;
    if (supportedBrowsers) {
      this.whiteListVersions.chromeAndroid = supportedBrowsers.androidMobile
        ? supportedBrowsers?.androidMobile.split(':')[1]
        : '97';
      this.whiteListVersions.chromeWindows = supportedBrowsers.desktopWindows
        ? supportedBrowsers?.desktopWindows.split(',')[0]?.trim().split(':')[1]
        : '97';
      this.whiteListVersions.edgeWindows = supportedBrowsers.desktopWindows
        ? supportedBrowsers?.desktopWindows.split(',')[1]?.trim().split(':')[1]
        : '99';
      this.whiteListVersions.safari = supportedBrowsers?.iosMobile
        ? supportedBrowsers?.iosMobile.split(':')[1]
        : '13.0';

      const browserMajorVersion = deviceInfoObj.browser.version.includes('.')
        ? parseInt(deviceInfoObj.browser.version.split('.')[0])
        : parseInt(deviceInfoObj.browser.version);
      const browserMinorVersion = deviceInfoObj.browser.version.includes('.')
        ? parseInt(deviceInfoObj.browser.version.split('.')[1])
        : parseInt(deviceInfoObj.browser.version);
      switch (deviceInfoObj.browser.name) {
        case 'Chrome':
          const supportedChromeVersion = parseInt(this.whiteListVersions.chromeWindows);
          browserMajorVersion && supportedChromeVersion <= browserMajorVersion
            ? (showWhiteList = false)
            : (showWhiteList = true);
          break;
        case 'Safari':
          const supportedSafariMajorVersion = parseInt(
            supportedBrowsers?.desktopMac.split(':')[1].split('.')[0],
          );
          const supportedSafariMinorVersion = parseInt(
            supportedBrowsers?.desktopMac.split(':')[1].split('.')[1],
          );
          browserMajorVersion &&
            supportedSafariMajorVersion <= browserMajorVersion &&
            supportedSafariMinorVersion <= browserMinorVersion
            ? (showWhiteList = false)
            : (showWhiteList = true);
          break;
        case 'Mobile Safari':
          const supportedMobileSafariMajorVersion = parseInt(
            supportedBrowsers?.iosMobile.split(':')[1].split('.')[0],
          );
          const supportedMobileSafariMinorVersion = parseInt(
            supportedBrowsers?.desktopMac.split(':')[1].split('.')[1],
          );
          browserMajorVersion &&
            supportedMobileSafariMajorVersion <= browserMajorVersion &&
            supportedMobileSafariMinorVersion <= browserMinorVersion
            ? (showWhiteList = false)
            : (showWhiteList = true);
          break;
        case 'Edge':
          const supportedEdgeVersion = parseInt(this.whiteListVersions.edgeWindows);
          browserMajorVersion && supportedEdgeVersion <= browserMajorVersion
            ? (showWhiteList = false)
            : (showWhiteList = true);
          break;
        default:
          showWhiteList = true;
          break;
      }
    } else {
      showWhiteList = true;
    }
    !showWhiteList
      ? (this.tunningResults.resultBrowser = true)
      : (this.tunningResults.resultBrowser = false);
    showWhiteList && this.showWhiteListAdvice(true);
    this.cdr.detectChanges();
  }

  postTunnings() {
    const tunningParams: IPostTunningRequest = this.utils.getTunningParams(this.tunningResults);
    console.log('tunningParams request', tunningParams);
    this.apiTunningService
      .postTunnings(tunningParams)
      .pipe(take(1))
      .subscribe({
        next: (tunningParams: IPostTunningRequest) => {
          if (tunningParams.id) {
            this.apiTunningService._tunningId = parseInt(tunningParams.id);
            console.log('tunningParams response', tunningParams);
          }
          this.cdr.detectChanges();
        },
        error: (err) => {
          this.devicesErrorMessage = true;
          this.cdr.detectChanges();
        }
      });
  }

  acceptNotSupportedBrowser() {
    this.showWhiteList = false;
    this.sessionStorageService.set('showedWhiteList', true);
    this.cdr.detectChanges();
  }
  closeModalLostSignal() {
    this.showLostSignalModalBS.next(false);
    this.cdr.detectChanges();
  }
  /**
   * Se obtienen los medios que dispone el dispositivo
   */
  getMedia() {
    const intervalId = this.meterLevelGenerator();

    this.opentokNetworkTestSrv.getNetWorkTestCredentials(
      environment.isPatient?this.attendantId:undefined
    ).subscribe({
      next: (data: any) => {
        console.log(
          'ApiTest getConnectionTestToken subscribe (' + this.utils.getTodayWithHour() + '): ',
          data,
        );
        this.opentokNetworkTestSrv.networkTestCredentials.sessionId = data?.sessionId;
        this.opentokNetworkTestSrv.networkTestCredentials.token = data?.token;
        this.opentokNetworkTestSrv.connectToTesting(data.sessionId, data.token);
        this.cdr.detectChanges();
      },
      error: (error) => {
        this.popUpMessage = this.translateService.instant(
          `MUTUA_NETWORK_TEST.GET_CREDENTIALS_ERROR`,
        );
        this.getNetWorkTestCredentialsError = true;
        console.log(
          'ApiTest getConnectionTestToken subscribe error (' +
          this.utils.getTodayWithHour() +
          '): ',
          error,
        );
        this.cdr.detectChanges();
      }
    });
    this.opentokNetworkTestSrv.dualCamObs$.subscribe((res) => {
      this.dualCam = res;
      if (res === true) {
        this.welcomeMessage = false;
        this.postTunnings();
      }
      this.cdr.detectChanges();
    });
    console.log(
      'MutuaNT stateHandlerSrv connectivity_test (' + this.utils.getTodayWithHour() + ')',
    );
    // IMPORTANTE: En cuanto se acaba el test de conectividad entra el subscribe.
    this.stateHandlerSrv.get('connectivity_test').subscribe((data) => {
      console.log(
        'MutuaNT connectivity_test subscribe (' + this.utils.getTodayWithHour() + '):',
        data,
      );
      if (data) {
        clearInterval(intervalId);
        this.levelWidth = 100;
        this.setConnectivityTestResults(data);
      }
      this.cdr.detectChanges();
    });

    // let stream2 = null;
    // try {
    //   stream2 = await navigator.mediaDevices.getUserMedia({ video: { facingMode: { exact: 'environment' } } });
    //   console.log(stream2);
    // } catch (err) {
    //   console.log(err);
    // }
  }
  /**
   * Se obtienen los participantes de la sala
   */
  attendantsData() {
    if (this.attendantId) {
      this.apiTunningService._attendantId = this.attendantId;
      console.log('MutuaNT getAttendants(attendantId) (' + this.utils.getTodayWithHour() + ')');
      // Obtenemos de back los datos de los participantes.
      this.apiConectateService.getAttendants(this.attendantId).subscribe((res: any) => {
        if (res) {
          console.log(
            'MutuaNT getAttendants(attendantId) subscribe (' + this.utils.getTodayWithHour() + '):',
            res,
          );
          this.mySelf = decodeURIComponent(escape(atob(res?.self?.c)));
          this.roleType = res?.self?.b;
          const otherParticipants = Object.assign([], res?.others);
          this.setAttendantsPhoneNumberByRoleType(res?.self?.b, otherParticipants);
          this.cdr.detectChanges();
        }
      });
      this.cdr.detectChanges();
    }
  }
  /**
   * Método para la asiganción del número de teléfono de contacto en el literal de errores del tunning.
   * @param roleType
   * @param otherParticipants
   */
  setAttendantsPhoneNumberByRoleType(roleType: string, otherParticipants: any) {
    const otherParticipantsSize = otherParticipants?.length;
    this.allPhonesNull =
      otherParticipants.filter((participant: any) => participant.a !== null).length === 0;
    // Todos los teléfonos de los participantes a null.
    if (this.allPhonesNull) {
      // Si el ususario es el amfitrion (doctor).
      if (roleType === PARTICIPANTS_CONSTANTS.ROL_TYPE.AMPHITRYON_SHORT) {
        // Solo 1 participante.
        if (otherParticipantsSize === 1) {
          this.phoneNumberToCall = otherParticipants[0]?.a ?? '33333';
        }
        // Más de 1 participante.
        if (otherParticipantsSize > 1) {
          for (let i = 0; i < otherParticipantsSize; i++) {
            if (otherParticipants[i].b === PARTICIPANTS_CONSTANTS.ROL_TYPE.USER_SHORT) {
              // Se escodifica el base-64 del número de teléfono.
              this.phoneNumberToCall =
                this.phoneNumberToCall + otherParticipants[i]?.a
                  ? atob(otherParticipants[i].a)
                  : '33333' + ', ';
            }
          }
          this.phoneNumberToCall = this.phoneNumberToCall.slice(0, -2);
        }
      }
      // Si el ususario es un paciente.
      if (roleType === PARTICIPANTS_CONSTANTS.ROL_TYPE.USER_SHORT) {
        this.setAmphitrionPhoneNumber(roleType, otherParticipants);
      }
      // Si existe algún número de teléfono.
    } else {
      this.setAmphitrionPhoneNumber(roleType, otherParticipants);
    }
    this.cdr.detectChanges();
  }
  /**
   * Método q asigna el teléfono del amfitrión (doctor) en los errores de tunning
   * @param roleType
   * @param otherParticipants
   */
  setAmphitrionPhoneNumber(roleType: string, otherParticipants: any) {
    const otherParticipantsSize = otherParticipants?.length;
    for (let i = 0; i < otherParticipantsSize; i++) {
      if (otherParticipants[i].b === PARTICIPANTS_CONSTANTS.ROL_TYPE.AMPHITRYON_SHORT) {
        // Se escodifica el base-64 del número de teléfono.
        this.phoneNumberToCall = otherParticipants[i]?.a ? atob(otherParticipants[i].a) : '';
      }
    }
  }
  /**
   * Barra de progresso del audio
   */
  meterLevelGenerator(): any {
    const totalDuration = this.opentokNetworkTestSrv.TEST_DURATION;
    const intervalDuration = 100 / totalDuration;

    const intervalId = setInterval(() => {
      if (this.devicesErrorMessage) {
        clearInterval(intervalId);
      } else if (this.levelWidth <= 100) {
        this.levelWidth = this.levelWidth + intervalDuration;
      } else {
        this.levelWidth = 100;
        clearInterval(intervalId);
      }
      this.cdr.detectChanges();
    }, intervalDuration);

    return intervalId;
  }

  /**
   * Se inicia el sonido del test de audio (pitidos)
   */
  playAudio() {
    this.audioStartTest = false;
    if (!this.audioOutputTest && this.audioTestObject) {
      if(window.location.origin.includes('localhost')){
        this.audioTestObject.src = '../../../../assets/338986__drfx__music-box-melody-1.mp3';
      }else{
        this.audioTestObject.src = this.enviroment.data?.features?.speakerTest?.url;
      }
      this.audioTestObject.play();
    }
    this.initPublisher();
    this.cdr.detectChanges();
  }

  /**
   * EL usuario ha informado de OK en el test de audio
   */
  audioTestOk() {
    const selectedAudioDevice = this.audioOutputDevices.find(
      (device: any) => device.deviceId === this.publisher?.getAudioSource()?.id,
    );
    console.log('Selected Audio Device:', selectedAudioDevice);
    if (selectedAudioDevice) {
      localStorage.setItem('selectedAudio', selectedAudioDevice.deviceId);
      console.log('Headset selected:', selectedAudioDevice.label);
    } else {
      console.error('No audio output device selected.');
    }
    if (this.audioTestObject) {
      this.audioTestObject.pause();
      this.audioTestObject.remove();
      this.audioTestObject = undefined;
    }
    this.audioOutputTest = true;
    this.audioManualTestEnabled = false;
    this.audioManualTest = false;
    this.audioManualTestInfo = false;
    this.micManualTestEnabled = true;
    this.micManualTest = true;
    //this.initPublisher();
    this.tunningResults.resultSpeakers = true;
    this.cdr.detectChanges();
  }

  /**
   * EL usuario ha informado de KO en el test de audio
   */
  audioTestKo() {
    this.typeDeviceErrorMessage = 'audio';
    this.audioManualTestEnabled = false;
    this.noAudioSpeakersTestPassed = true;
    if (this.audioTestObject) {
      this.audioTestObject.pause();
    }
    if (this.tunningResults) {
      this.tunningResults.resultSpeakers = false;
      this.tunningResults.resultMicrophone = false;
      this.tunningResults.resultCamera = false;
    }
    this.postTunnings();
    this.cdr.detectChanges();
  }

  /**
   * Se inicializa el publisher en OT, para iniciar el servicor de publicaciones del usuario para el test
   * @param {string} [width] ancho de la pantalla de la cámara para el test del usuario
   * @param {string} [height] alto de la pantalla de la cámara para el test del usuario
   */
  /**
   * Helper method to filter media devices consistently
   * @param devices Array of media devices to filter
   * @returns Filtered and sorted array of devices
   */
  filterMediaDevices(devices: any[]): any[] {
    if (!devices || devices.length === 0) {
      return [];
    }

    // Filter out devices with reserved IDs
    const reservedIds = ['default', 'communications'];
    let filteredDevices = devices.filter((device) => {
      return !reservedIds.includes(device.deviceId);
    });

    // Sort devices alphabetically by label
    filteredDevices.sort((a, b) => {
      return a.label.localeCompare(b.label);
    });

    return filteredDevices;
  }


/**
   * Special filter function for audio output devices that preserves the filtering logic
   * but also identifies the default device for automatic selection
   * @param devices Array of audio output devices to filter
   * @returns Object containing filtered devices and the default device ID
   */
  filterAudioOutputDevices(devices: any[]): { filteredDevices: any[], defaultDeviceId: string | null } {
    if (!devices || devices.length === 0) {
      return { filteredDevices: [], defaultDeviceId: null };
    }

    // Find the default device before filtering
    const defaultDevice = devices.find(device => device.deviceId === 'default');
    let defaultDeviceId = null;

    // If we found a default device, try to determine which actual device it corresponds to
    if (defaultDevice) {
      // The label of the default device often contains the actual device name
      // We'll use this to find the corresponding non-default device
      const defaultLabel = defaultDevice.label;
      
      // Look for a device with a similar label but not with a reserved ID
      const reservedIds = ['default', 'communications'];
      const matchingDevice = devices.find(device => {
        return !reservedIds.includes(device.deviceId) && 
               defaultLabel.includes(device.label);
      });

      if (matchingDevice) {
        defaultDeviceId = matchingDevice.deviceId;
      }
    }

    // Apply the same filtering logic as filterMediaDevices
    const reservedIds = ['default', 'communications'];
    let filteredDevices = devices.filter((device) => {
      return !reservedIds.includes(device.deviceId);
    });

    // Sort devices alphabetically by label
    filteredDevices.sort((a, b) => {
      return a.label.localeCompare(b.label);
    });

    return { filteredDevices, defaultDeviceId };
  }




  initPublisher(width?: string, height?: string) {
    const percent = '%';
    const frameRateRecommended = this.frameRateRecommended;
    const config = {
      frameRate: frameRateRecommended ? frameRateRecommended : 15, // 30, 15, 7, or 1
      enableDtx: true,
      width: (width ?? '100') + percent,
      height: (height ?? '100') + percent,
      insertMode: 'append',
      style: {
        audioLevelDisplayMode: 'off',
        buttonDisplayMode: 'off',
        nameDisplayMode: 'off',
      },
      showControls: true,
      publishAudio: true,
      publishVideo: true,
    };
    this.ot = this.opentokService.getOT();
    console.log(
      'MutuaNT this.opentokService.getOT() (' + this.utils.getTodayWithHour() + '):',
      this.ot,
    );
    this.publisher = this.ot.initPublisher(
      this.publisherDiv &&this.publisherDiv.nativeElement,
      config,
      this.catchErrorMediaDevices,
    );
    console.log(
      'MutuaNT ot.initPublisher (' + this.utils.getTodayWithHour() + '):',
      this.publisher,
    );

    this.utils.getHardwareDevices(this.ot).subscribe((devices) => {
      // Process audio input devices (microphones)
      if (devices && devices.audioList) {
        const filteredDevices = this.filterMediaDevices(devices.audioList);

        // Check if we have both "Headset earpiece" and "Speakerphone" devices
        const hasHeadsetEarpiece = filteredDevices.some((device) =>
          /headset earpiece/i.test(device.label),
        );

        const hasSpeakerphone = filteredDevices.some((device) =>
          /speakerphone/i.test(device.label),
        );

        // Additional filter to remove "Headset earpiece" when both are present
        let finalAudioDevices = filteredDevices;
        if (hasHeadsetEarpiece && hasSpeakerphone) {
          // Filter out Headset earpiece devices
          finalAudioDevices = filteredDevices.filter(
            (device) => !/headset earpiece/i.test(device.label),
          );

          // Only apply the filter if we still have devices left
          if (finalAudioDevices.length === 0) {
            finalAudioDevices = filteredDevices;
          }
        }

        this.audioDevices = finalAudioDevices.map((device) => ({
          ...device,
          truncatedLabel:
            device.label.length > 35 ? device.label.substring(0, 35) + '...' : device.label,
        }));
        
        console.log('MNT audioDevices (after filtering):', this.audioDevices);
      }

      // Process video devices (cameras)
      if (devices && devices.videoList) {
        const filteredDevices = this.filterMediaDevices(devices.videoList);

        if(devices.defaultVideoDevice && devices.defaultVideoDevice[0]?.deviceId){
          this.defaultVideoInputDeviceId = devices.defaultVideoDevice[0].deviceId;
          
        }
        this.videoDevices = filteredDevices.map((device) => ({
          ...device,
          truncatedLabel:
            device.label.length > 35 ? device.label.substring(0, 35) + '...' : device.label,
        }));

        console.log('MNT videoDevices (after filtering):', this.videoDevices);
      }

      // Process audio output devices (speakers)
      if (devices && devices.audioOutputList) {
        // const filteredDevices = this.filterMediaDevices(devices.audioOutputList);


        // Use the special filter function for audio output devices
        const { filteredDevices, defaultDeviceId } = this.filterAudioOutputDevices(devices.audioOutputList);
        
        // Store the default device ID for later use
        this.defaultAudioOutputDeviceId = defaultDeviceId;
        // Also set it as the selected device so it's pre-selected in the dropdown
        if (defaultDeviceId) {
          this.selectedAudioOutputDeviceId = defaultDeviceId;
          // Store in localStorage for persistence
          localStorage.setItem('selectedHeadset', defaultDeviceId);
        }
        
        console.log('Default audio output device ID:', defaultDeviceId);


        // Check if we have both "Headset earpiece" and "Speakerphone" devices
        const hasHeadsetEarpiece = filteredDevices.some((device) =>
          /headset earpiece/i.test(device.label),
        );
        const hasSpeakerphone = filteredDevices.some((device) =>
          /speakerphone/i.test(device.label),
        );

        // For Android devices, handle audio output selection based on available devices
        let finalAudioOutputDevices = filteredDevices;

        // If we're on Android and have both headset earpiece and speakerphone
        if (hasHeadsetEarpiece && hasSpeakerphone) {
          // Filter out Headset earpiece devices when both are present
          finalAudioOutputDevices = filteredDevices.filter(
            (device) => !/headset earpiece/i.test(device.label),
          );

          // Only apply the filter if we still have devices left
          if (finalAudioOutputDevices.length === 0) {
            finalAudioOutputDevices = filteredDevices;
          }
        }



        this.audioOutputDevices = finalAudioOutputDevices.map((device) => ({
          ...device,
          truncatedLabel:
            device.label.length > 35 ? device.label.substring(0, 35) + '...' : device.label,
        }));

        console.log('MNT audioOutputDevices (after filtering):', this.audioOutputDevices);
        this.cdr.detectChanges();
      }
    });

    /**
     *
     *
    this.publisher.on('streamCreated', (event) => {
      const subscriberOptions = { testNetwork: true };
      const subscriber = session.subscribe(event.stream, 'publisher-element', subscriberOptions);
    }
     */

    this.audioMicLevel();
    this.cdr.detectChanges();
  }

  catchErrorMediaDevices(error: OTError, video?: boolean, audio?: boolean) {
    if (error) {
      console.log(error);
      switch (error.name) {
        case VIDEOCONFERENCE_CONSTANTS.MEDIA_DEVICES_ERRORS.NOT_ALLOWED_ERROR:
          this.popUpMessage = this.translateService.instant(`MUTUA_NETWORK_TEST.ALLOW_DEVICES`);
          break;

        case VIDEOCONFERENCE_CONSTANTS.MEDIA_DEVICES_ERRORS.NOT_READABLE_ERROR:
          this.popUpMessage = this.translateService.instant(`MUTUA_NETWORK_TEST.BUSY_DEVICES`);
          break;
        default:
          this.popUpMessage = this.translateService.instant(`MUTUA_NETWORK_TEST.BUSY_DEVICES`);
      }

      this.devicesErrorMessage = true;
    }
  }

  showWhiteListAdvice(status: boolean) {
    if (status) {
      const showedWhiteList = this.sessionStorageService.get('showedWhiteList');
      if (!showedWhiteList) {
        this.showWhiteList = true;
        this.popUpMessage = '';
      }
    } else {
      this.showWhiteList = false;
    }
  }

  onSeleccionar(valRef: any) {
    const value = valRef.value;
    if (this.audioDevices && this.audioDevices.length > 0) {
      const selectedDevice = this.audioDevices.find((device: any) => device.deviceId === value);
      if (selectedDevice && this.publisher) {
        this.publisher
          .setAudioSource(selectedDevice.deviceId)
          .then(() => {
            console.log('Audio switched to:', selectedDevice.deviceId);
          })
          .catch((error) => {
            console.error('Error switching microphone:', error);
          });
      } else {
        console.error('Selected device not found in available audio devices.');
      }
    }
  }

  onSeleccionarAudio(valRef: any) {
    const value = valRef.value;
    if (this.audioTestObject) {
      this.audioTestObject.pause();
      this.audioTestObject.remove();
    }
    if (this.audioOutputDevices && this.audioOutputDevices.length > 0) {
      const selectedDevice = this.audioOutputDevices.find(
        (device: { deviceId: string; label: string }) => device.deviceId === value,
      );
      if (selectedDevice) {
        // Set the audio output device for OpenTok
        this.ot
          .setAudioOutputDevice(selectedDevice.deviceId)
          .then(() => {
            localStorage.setItem('selectedHeadset', selectedDevice.deviceId);
            if (this.audioTestObject) {
              this.audioTestObject.play();
              this.cdr.detectChanges();
            }
            // If we have an audio test object, update its output as well (if browser supports it)
            if (this.audioTestObject &&  this.audioTestObject.setSinkId) {
              this.audioTestObject
                .setSinkId(selectedDevice.deviceId)
                .then(() => {
                  console.log('Audio test object output changed');
                  if (this.audioTestObject) {
                    this.audioTestObject.play();
                    this.cdr.detectChanges();
                  }
                })
                .catch((error: Error) => {
                  console.error('Error setting audio test output:', error);
                });
            } else {
              if (this.audioTestObject) {
                this.audioTestObject?.play();
                this.cdr.detectChanges();
              }
            }
          })
          .catch((error: Error) => {
            console.error('Error switching speaker device:', error);
          });
      } else {
        console.error('Selected device not found in available audio output devices.');
      }
    }
  }

  async onSeleccionarCam(valRef: any) {
    console.log(await navigator.mediaDevices.enumerateDevices());
    const value = valRef.value;
    if (this.videoDevices && this.videoDevices.length > 0) {
      const selectedDevice = this.videoDevices.find((device: any) => device.deviceId === value);
      if (selectedDevice && this.publisher) {
        this.publisher
          .setVideoSource(selectedDevice.deviceId)
          .then(() => {
            console.log('Cam switched to:', selectedDevice.deviceId);
            this.cdr.detectChanges();
          })
          .catch((error) => {
            console.error('Error switching cam:', error);
            this.cdr.detectChanges();
          });
      } else {
        console.error('Selected device not found in available cam devices.');
        this.cdr.detectChanges();
      }
    }
  }
  // Method that check the audio Level for the meter of audio
  audioMicLevel() {
    if(this.publisher){
      this.publisher.setStyle('audioLevelDisplayMode', 'off');
      let movingAvg: any = null;
      this.publisher.on(
        'audioLevelUpdated',
        (event) => {
          // console.log('MNT audioMicLevel movingAvg:', movingAvg);
          if (movingAvg === null || movingAvg <= event.audioLevel) {
            movingAvg = event.audioLevel;
            movingAvg = movingAvg * 1000 ? movingAvg * 10 : movingAvg;
            movingAvg = movingAvg === 0 ? 0.07 : movingAvg;
          } else {
            movingAvg = 0.7 * movingAvg + 0.3 * event.audioLevel;
          }
          // 1.5 scaling to map the -30 - 0 dBm range to [0,1]
          let logLevel = Math.log(movingAvg) / Math.LN10 / 1.5 + 1;
          logLevel = Math.min(Math.max(logLevel, 0), 1);
          if (<HTMLInputElement>document.querySelector('#publisherMeter')) {
            (<HTMLInputElement>document.querySelector('#publisherMeter')).value =
              logLevel?.toString();
          }
          if (this.audioLevelCont % 40 === 0) {
            console.log('********** MNT audioMicLevel********');
            console.log('MNT audioMicLevel event Level:', event.audioLevel);
            console.log('MNT audioMicLevel logLevel:', logLevel);
            console.log('******** END MNT audioMicLevel *********');
          }
          this.audioLevelCont++;
          this.cdr.detectChanges();
        },
        this,
      );
    };
  }

  playMic() {
    this.micStartTest = true;
    this.cdr.detectChanges();
  }

  micTestOk() {
    this.publisher && localStorage.setItem('selectedMic', this.publisher.getAudioSource().id);
    this.micManualTestEnabled = false;
    this.camManualTestEnabled = true;
    this.micManualTest = false;
    this.micManualTestInfo = false;
    this.camManualTest = true;
    // tslint:disable-next-line:no-unused-expression
    this.publisher && this.publisher.off('audioLevelUpdated');
    this.tunningResults.resultMicrophone = true;
    this.cdr.detectChanges();
  }

  micTestKo() {
    this.typeDeviceErrorMessage = 'mic';
    this.micManualTestEnabled = false;
    this.noAudioSpeakersTestPassed = true;
    // tslint:disable-next-line:no-unused-expression
    this.publisher && this.publisher.off('audioLevelUpdated');
    this.tunningResults.resultMicrophone = false;
    this.tunningResults.resultCamera = false;
    this.postTunnings();
    this.cdr.detectChanges();
  }

  playCam() {
    this.camStartTest = true;
    this.cdr.detectChanges();
  }

  camTestOk() {
    localStorage.setItem('selectedCam', (this.publisher?.getVideoSource().deviceId as string | ''));
    this.camManualTestEnabled = false;
    this.camManualTest = false;
    this.camManualTestInfo = false;
    this.tunningResults.resultCamera = true;
    this.navigateToRoom();
    this.cdr.detectChanges();
  }

  camTestKo() {
    this.typeDeviceErrorMessage = 'cam';
    this.camManualTestEnabled = false;
    this.noAudioSpeakersTestPassed = true;
    this.publisher?.off('audioLevelUpdated');
    this.tunningResults.resultCamera = false;
    this.postTunnings();
    this.cdr.detectChanges();
  }

  /**
   * Asignación resultados de test de conectividad de Vonage para video/audio/red
   */
  setConnectivityTestResults(results: any) {
    this.audioTest = results?.audio?.supported;
    this.videoTest = results?.video?.supported;
    this.frameRateRecommended = results?.video?.recommendedFrameRate;
    this.stateHandlerSrv.set('recommendedFrameRate', true);
    this.networkTest = this.audioTest && this.videoTest;
    this.testResults();
    this.testResultsShownInDevelop = this.enviroment.data?.environment === 'dev' ? results : false;
    this.cdr.detectChanges();
  }

  /**
   * Mostrar Resultados de test de conectividad de Vonage para video/audio/red
   */
  testResults() {
    this.welcomeMessage = false;
    this.showConnectivityTestResults = false;
    if (this.devicesTestActivate && this.networkTest) {
      this.audioManualTestEnabled = true;
      this.audioStartTest = true;
      this.audioManualTest = true;
      this.audioManualTestInfo = true;
      this.tunningResults.resultNetwork = true;
      // tslint:disable-next-line:no-unused-expression
      // this.audioOutputTest && this.navigateToRoom();
    } else {
      this.noConnectivityTestPassed = true;
      this.tunningResults = {
        resultNetwork: false,
        resultCamera: false,
        resultMicrophone: false,
        resultBrowser: false,
        resultSpeakers: false,
      };
      this.postTunnings();
    }
    this.cdr.detectChanges();
  }

  reloadPage() {
    window.location.reload();
  }
  //TODO: si se quiere un control de los medios del dispositivo antes de Iniciar
  //el test
  // async areDevicesNoAllowed() {
  //   console.log('PEDIR PERMISOS DE AUDIO Y VIDEO');
  //   console.log(
  //     'areAvailableMediaDevices: ',
  //     this.utils.areAvailableMediaDevices()
  //   );
  //   this.resultNavigatorMediaAllowed({ video: true }).then(
  //     (result: { [key: string]: boolean }) => {
  //       console.log('areDevicesNoAllowed', result);
  //       switch (true) {
  //         case result.video:
  //           console.log('VIDEO ALLOWED');
  //           this.resultNavigatorMediaAllowed({ audio: true }).then(
  //             (result: { [key: string]: boolean }) => {
  //               switch (true) {
  //                 case result.hasOwnProperty('video'):
  //                   console.log('VIDEO NOT ALLOWED');
  //                   this.isMediaErrorBS.next(true);
  //                   break;
  //                 case result.hasOwnProperty('audio'):
  //                   console.log('AUDIO NOT ALLOWED');
  //                   this.isMediaErrorBS.next(true);
  //                   break;
  //               }
  //             }
  //           );
  //           break;
  //         case result.audio:
  //           console.log('AUDIO/VIDEO ALLOWED');
  //           this.isMediaErrorBS.next(false);
  //           break;
  //       }
  //     }
  //   );
  // }
  // async resultNavigatorMediaAllowed(mediaTest) {
  //   return await this.checkNavigatorMediaAllowed(mediaTest);
  // }
  // async checkNavigatorMediaAllowed(mediaTest) {
  //   return new Promise((resolve, reject) => {
  //     navigator.mediaDevices
  //       .getUserMedia(mediaTest)
  //       .then((stream) => {
  //         console.log(
  //           mediaTest.video ? 'video stream ok' : 'audio stream ok',
  //           stream
  //         );
  //         resolve(mediaTest);
  //       })
  //       .catch((e) => {
  //         console.log(
  //           mediaTest.video ? 'video stream ok' : 'audio stream ok',
  //           e
  //         );
  //         resolve(mediaTest.video ? { video: false } : { audio: false });
  //       });
  //   });
  // }
  /**
   * Se navega a la sala de la videoconferencia
   */
  private navigateToRoom() {
    const attendantId =
      this.activatedRoute.snapshot.queryParams[VIDEOCONFERENCE_CONSTANTS.URL_PARAM_ATTENDANT];
    this.postTunnings();
    //Destruimos el publisher de OT usado para los test
    //Importante porque se queda asignado el hardware de audio y video y provoca problemas
    //this.publisher.off();
    //this.publisher.destroy();

    console.log('Selected Camera:', this.publisher?.getVideoSource());
    console.log('Selected mic:', this.publisher?.getAudioSource());

    const pin = this.activatedRoute.snapshot.queryParams[VIDEOCONFERENCE_CONSTANTS.URL_PARAM_PIN];

    const queryParams =
      this.enviroment.data?.features?.pin_required && pin
        ? { access: attendantId, pin }
        : { access: attendantId };

    const navigationExtras: NavigationExtras = {
      queryParams: queryParams,
      replaceUrl: true,
    };
    this.router.navigate([ROUTES_CONSTANTS.ROOM.path], navigationExtras);
    this.cdr.detectChanges();
  }

  ngOnDestroy(): void {
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
  }
}
